import {
  generateSignedM3u8Url,
  generateSignedUrl,
} from "./generatePreSignedUrl";
import { parseM3u8ToExtractThumbnailManifestFileName } from "./m3u8Parser";

import type { Cookie } from "@spwn/types/functions";

export const fetchThumbnailManifest = async ({
  cookie: { url: cookieUrl, cookie },
}: {
  cookie: Pick<Cookie, "url" | "cookie">;
}): Promise<string | undefined> => {
  const manifestFileUrl = generateSignedM3u8Url(cookieUrl, cookie);
  const response = await fetch(manifestFileUrl);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const manifestFileData = await response.text();
  const thumbnailManifestFileName =
    parseM3u8ToExtractThumbnailManifestFileName(manifestFileData);

  if (!thumbnailManifestFileName) {
    console.warn("No thumbnail manifest file name found.");
    return undefined;
  }

  const thumbnailIndexUrl = generateSignedUrl({
    manifestFileUrl: cookieUrl,
    cookie,
    fileName: thumbnailManifestFileName,
  });

  const thumbnailManifestFileResponse = await fetch(thumbnailIndexUrl);

  if (!thumbnailManifestFileResponse.ok) {
    throw new Error(
      `HTTP error! status: ${thumbnailManifestFileResponse.status}`
    );
  }
  const thumbnailManifestFileData = await thumbnailManifestFileResponse.text();

  return thumbnailManifestFileData;
};
